import * as Forms        from '../components/forms';
import OnboardingSection from './onboarding_section';
import React             from 'react';
import useCompleted      from './use_completed';
import zxcvbn            from 'zxcvbn';


export default function PasswordSection({ profile, updateProfile }) {

  const { isCollapsed, complete } = useCompleted('onboarding-created-password', false);

  const { email }      = profile;
  const forEmailString = email ? ` for ${email}` : '';

  async function changePassword({ newPassword, currentPassword }) {
    await updateProfile({ password: newPassword, currentPassword }, { showDefaultErrorUI: false });
    complete();
  }

  return (
    <OnboardingSection className="password" collapsed={isCollapsed}>
      <h2>Create your password</h2>
      <div className="not-completed-section">
        <p>
          Create and confirm a strong password{forEmailString}, to login to Broadly in the future.
        </p>
        <Forms.Form save={changePassword} validate={validate}>
          <PasswordFields/>
        </Forms.Form>
      </div>
    </OnboardingSection>
  );
}


function PasswordFields({ ...form }) {
  return (
    <ul>
      <Forms.PasswordStrengthInput {...form} label="New Password" name="newPassword"/>
      <Forms.PasswordStrengthInput {...form} label="Confirm New Password" name="confirmNewPassword"/>
      <Forms.Error {...form}/>
      <Forms.Button {...form} label="Create Password"/>
    </ul>
  );
}


const bothPasswordsRequired = 'Please enter your password in both fields.';
const passwordsMustMatch    = 'Both passwords must match. Please try again.';
const weakPassword          = 'For a strong password we recommend using at least 8 characters, with a mix of uppercase and lowercase letters, numbers, and special characters.';

function validate(fields) {
  if (!fields.newPassword || !fields.confirmNewPassword)
    throw new Error(bothPasswordsRequired);

  if (fields.newPassword !== fields.confirmNewPassword)
    throw new Error(passwordsMustMatch);

  if (zxcvbn(fields.newPassword).score < 2)
    throw new Error(weakPassword);
}
